export const drawZeroLine = ({
  u,
  si,
  tradeUnit,
}: {
  u: uPlot;
  si: number;
  tradeUnit: string;
}) => {
  const ctx = u.ctx;
  ctx.save();
  const s = u.series[si];
  const [i0, i1] = s.idxs as [number, number];
  const xSeries = u.data[0];
  const x0 = u.valToPos(xSeries[i0], "x", true);
  const x1 = u.valToPos(xSeries[i1], "x", true);
  const y = u.valToPos(0, tradeUnit, true);
  ctx.beginPath();
  ctx.setLineDash([12]);
  ctx.moveTo(x0, y);
  ctx.lineTo(x1, y);
  ctx.lineWidth = 1;
  ctx.strokeStyle = "#939393";
  ctx.stroke();
  ctx.restore();
};
